<template>
  <div>
  <loading-container :state="state" errormsg="Beim Laden der Linkliste ist ein Fehler aufgetreten.">
    <div class="mb-5 d-block">
      <div class="row">
        <div class="col-12">
          <p class="f-20" v-if="!changeable">{{ textStandard}}</p>
          <p class="f-20" v-else>{{ textEdit}}</p>
        </div>
        <div class="col-12" v-if="changeable">
          <div class="mb-4 d-flex justify-content-end col-12 pr-0">
            <button class="btn btn-link mr-3" @click="cancelList()">Abbrechen</button>
            <button class="btn btn-primary btn-anwendungen" @click="saveList()">Änderungen speichern</button>
          </div>
          <form @submit.prevent="addUrlToList" >
            <div class="linkform d-flex">
              <div class="pb-2 pr-4 w-50">
                <label class="pr-2" for="externalLinkName">Name: </label>
                <input v-model="newLinkName" type="text" class="mr-4 form-control" id="externalLinkName" name="externalLinkName" placeholder="">
              </div>
              <div class="pb-2 w-50">
                <label class="pr-2" for="externalLink">Link: </label>
                <input class="mb-2 form-control" v-model="newLink" type="url" id="externalLink" name="externalLink" placeholder="https://...">
              </div>
            </div>
            <button type="submit"  class="mb-4 btn btn-primary">Link hinzufügen</button>
          </form>
        </div>
        <div class="col-12 d-flex justify-content-end" v-else>
          <button class="btn btn-primary btn-anwendungen" @click="changechange">Linkliste bearbeiten</button>
        </div>
      </div>
    </div>
    <div class="mb-5 favoritenliste d-block">
      <div class="row">
        <div class="col-12">
          <div v-if="!changeable">
            <ul class="list-group list-unstyled">
              <li class="list-group-item mb-0" v-for="item in list" :key="item.id">
                <template >
                  <a :href="sanitizeUrl(item.resolvedUrl || item.externalUrl)" class="d-flex align-items-center fs-16"  target="_blank" rel="noreferrer noopener">
                    <div>{{ item.resolvedName || item.name }}</div>
                    <div><i class="fas fa-external-link-alt ml-2 fs-12"></i><span class="sr-only">öffnen</span></div>
                  </a>
                </template>
              </li>
            </ul>
          </div>
          <div v-else>
          <draggable
            tag="ul"
            :list="list"
            class="list-group list-unstyled"
            handle=".handle"
            v-bind="dragOptions"
            @start="drag = true"
            @end="drag = false"
            item-key="name"
          >
            <template #item="{ element, index }">
              <li class="list-group-item mb-0">
                <div class="d-flex justify-content-between">
                  <div class="d-flex align-items-center">
                    <i class="fas fa-grip-horizontal handle mr-3" aria-hidden="true"></i>
                    <div class="form-check mr-3">
                      <span class="text">{{ element.resolvedName || element.name }} </span>
                    </div>
                  </div>
                  <div class="d-flex">
                    <button v-if="index > 0" class="btn btn-arrow py-0 fs-12" @click="moveUp(index)"><i class="fas fa-long-arrow-alt-up"></i></button>
                    <button v-if="index < (list.length -1)" class="btn btn-arrow py-0 fs-12" @click="moveDown(index)"><i class="fas fa-long-arrow-alt-down"></i></button>
                    <button  class="loeschen-btn" type="button" title="Link entfernen" @click="deleteFavorite(index)"> <i class="icon icon-loeschen"></i> </button>
                  </div>
                </div>
              </li>
            </template>
          </draggable>
          </div>
        </div>
      </div>
    </div>
  </loading-container>
  </div>
</template>

<script lang="ts">
import draggable from "vuedraggable";
import { defineComponent } from 'vue'
import LoadingMixin from '@/mixins/LoadingMixin'
import LoadingContainer from '@/components/structure/LoadingContainer.vue'
import { sanitizeUrl } from '@braintree/sanitize-url'
import linkverwaltungService from "./services/linkverwaltungService";
import { BhagLinkResolved } from "./models/BhagLinkverwaltung";
import { LoadingState } from "./utils/loadingUtils";

export default defineComponent({
  props:{
    favoritenlisteBhagJsonUrl: {
      type: String,
      required: true
    }
  },
  name: "Linkliste",
  display: "Linkliste",
  instruction: "Drag using the handle icon",
  order: 5,
  components: {
    draggable,
    LoadingContainer
  },
  mixins: [
    LoadingMixin
  ],
  data() {
    return {
      newLinkName:"",
      newLink:"",
      changeable: false,
      list: [] as BhagLinkResolved[],
      drag: false,
      textStandard: (document.querySelector('[data-favoritenliste-bhag-text-standard]') as HTMLElement).dataset.favoritenlisteBhagTextStandard ||'' ,
      textEdit: (document.querySelector('[data-favoritenliste-bhag-text-edit]') as HTMLElement).dataset.favoritenlisteBhagTextEdit ||'' ,
      sanitizeUrl: sanitizeUrl
    };
  },
  computed: {
    draggingInfo(): string {
      return this.drag ? "under drag" : "";
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },

  },

  created() {
    linkverwaltungService
      .getMyLinksBhag(this.favoritenlisteBhagJsonUrl)
      .then(links => {
        this.list = links
        this.handleSuccess()
      }).catch(this.handleError)
  },
  methods: {
    deleteFavorite(index: any){
      this.list.splice(index,1)
    },
    addUrlToList(){
      if (this.newLink.trim() !== "") {
        this.list.push({
        favorite: true,
        internal: false,
        name: this.newLinkName,
        externalUrl: this.newLink,
        },)}
     this.newLink = "";
     this.newLinkName=""
    },
    changechange(){
      this.changeable = !this.changeable
    },
    swapArrayElements (arr: any, indexA: number, indexB: number) {
          const temp = arr[indexA];
          arr[indexA] = arr[indexB];
          arr[indexB] = temp;
        },
    moveUp(idx: number){
      if(idx !== 0){
        const idx_new = idx - 1;
        this.swapArrayElements(this.list, idx, idx_new);
      }
    },
    moveDown(idx: number){
      if(idx < (this.list.length-1)){
        const idx_new = idx + 1;
        this.swapArrayElements(this.list, idx, idx_new);
      }
    },
   saveList(){
      this.changeable = false;
      this.state= LoadingState.loading
      linkverwaltungService
        .saveMyLinksBhag(this.list)
        .then(() => {
         return linkverwaltungService.getMyLinksBhag(this.favoritenlisteBhagJsonUrl)
        })
        .then(links => {
        this.list = links
        this.handleSuccess()
      })
        .catch(this.handleError)
    },

    cancelList(){
      this.changeable = false;
      location.reload();
    },
    /*
    changeFavCheckbox(idx: number){
      this.list[idx].favorite = !this.list[idx].favorite;
    },*/
  },

});
</script>

<style scoped>
@import 'assets/css/fontawesome.6.4.1.all.min.css';

@media (max-width:575px ) {
  .linkform div.w-50 {
    width: 100% !important;
    padding-right: 0px !important;
  }
}
template{
  display: block;
}
.loeschen-btn{
  padding:0px;
  border-width: 0px;
  background-color: #fff;
}
.icon-loeschen:before {
    content: "\e975";
    font-size: 15px;
}
.fs-12 {
  font-size: 0.75rem;
}

.fs-16 {
  font-size: 1rem;
}

.list-group-item + .list-group-item {
    border-top-width: 0;
}
.list-group-item {
    position: relative;
    display: block;
    padding: 0.5rem 1rem;
    text-decoration: none;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);
}

.form-check {
    display: block;
    min-height: 1.5rem;
    padding-left: 1.5em;
    margin-bottom: 0.125rem;
}

.form-check-input:checked[type=checkbox] {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");
}
.form-check-input:checked {
    background-color: #286f9c;
    border-color: #286f9c;
}
.form-check-input[type=checkbox] {
    border-radius: 0.25em;
}
.form-check .form-check-input {
    float: left;
    margin-left: -1.5em;
    margin-top: 7px;
}
.form-check-input {
    width: 1em;
    height: 1em;
    margin-top: 0.25em;
    vertical-align: top;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    border: 1px solid rgba(0, 0, 0, 0.25);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
}
input, button, select, optgroup, textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}
.linkform{
  padding-bottom:1rem;
  flex-wrap: wrap;
}
</style>
